import React from 'react';
import { generateArticleTrioCards } from '../CardTrio/articleCardTrioInputs';
import { CardTrio } from '../CardTrio/CardTrio';
import { CardTrioCard } from '../CardTrio/CardTrioCard';
import './LatestNewsAndUpdates.scss';
import { SmartLink } from '../SmartLink/SmartLink';

export const LatestNewsAndUpdates = ({ node }) => {
    if (
        !node.relationships.field_article_trio ||
        !node.relationships.field_article_trio.length
    ) {
        return <></>;
    }
    const cardTrioSchema = generateArticleTrioCards(
        node.relationships.field_article_trio.slice(1, 4),
        true
    );

    const [cardNode] = node.relationships.field_article_trio;

    if (!cardNode) return <></>;

    const mainCard: CardTrioCard = {
        id: cardNode.id,
        title: cardNode.title,
        eyebrow: cardNode.relationships.field_news_category?.name,
        description: cardNode.field_summary,
        image:
            cardNode.relationships.field_alternate_image?.relationships
                ?.field_media_image.localFile ??
            cardNode.relationships?.field_news_image?.relationships
                ?.field_media_image_1.localFile,
        imageAlt:
            cardNode.relationships?.field_alternate_image?.field_media_image
                ?.alt ??
            cardNode.relationships?.field_news_image?.field_media_image_1?.alt,
        large: true,
        linkUrl: cardNode.fields?.url,
        news: true,
        linkText: `Read this article`,
    };

    return (
        <section className="paragraph__latest-news kite-container">
            <h2>{node.field_main_title}</h2>
            <ul>
                <CardTrioCard card={mainCard}></CardTrioCard>
            </ul>
            <CardTrio
                inputs={{
                    id: `featuredCards`,
                    inline: true,
                    cards: cardTrioSchema,
                }}
            />
            {node.field_more_news && (
                <SmartLink button={true} url={node.field_more_news?.uri}>
                    {node.field_more_news.title}
                </SmartLink>
            )}
        </section>
    );
};
